const entrepreneurshipPhilanthropySteps = [
    {
        id: 8,
        area: 'Entrepreneurship & Philanthropy',
        stepTitle: 'Entrepreneurship & Philanthropy Pre-Workshop Assessment',
        stepDescription: ``,
        preWorkshop: true, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "What is net worth?", options: [
            'What you are worth socially once you combine your social media followers and personal contacts.', 
            'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 
            'What you are worth intellectually once you combine your degrees and work experience.', 
          ],
          correctAnswer: 'What you are worth socially once you combine your social media followers and personal contacts.' 
        },
        { id: 2, title: "Why is it important to at least pay the minimums of credit cards?", options: [
          'So that I can increase my savings.', 
          'So that I can spend more money.', 
          'So that I can maintain a good credit score.', 
        ],
        correctAnswer: 'So that I can maintain a good credit score.'
        },
        { id: 3, title: "What is a credit score?", options: [
          'The number—based on your credit history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
          'The number—based on your saving history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
          'The number—based on your investment history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
        ],
        correctAnswer: 'The number—based on your saving history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.', 
    
        },
        { id: 4, title: "Why is it important to at least pay the minimums of credit cards?", options: [
          'So that I can increase my savings.', 
          'So that I can spend more money.', 
          'So that I can maintain a good credit score.', 
        ],
        correctAnswer: 'So that I can increase my savings.', 
        },
        { id: 5, title: "2Why is it important to at least pay the minimums of credit cards?", options: [
          'So that I can increase my savings.', 
          'So that I can spend more money.', 
          'So that I can maintain a good credit score.', 
        ],
        correctAnswer: 'So that I can maintain a good credit score.',
        },
        { id: 6, title: "3Why is it important to at least pay the minimums of credit cards?", options: [
          'So that I can increase my savings.', 
          'So that I can spend more money.', 
          'So that I can maintain a good credit score.', 
        ],
        correctAnswer: 'So that I can spend more money.',  
        },
        { id: 7, title: "4Why is it important to at least pay the minimums of credit cards?", options: [
          'So that I can increase my savings.', 
          'So that I can spend more money.', 
          'So that I can maintain a good credit score.', 
        ],
        correctAnswer: 'So that I can spend more money.', 
        },
        { id: 8, title: "5Why is it important to at least pay the minimums of credit cards?", options: [
          'So that I can increase my savings.', 
          'So that I can spend more money.', 
          'So that I can maintain a good credit score.', 
        ],
        correctAnswer:   'So that I can maintain a good credit score.', 
        },
        ],
        nextStep: 9
      },
      {
        id: 9,
        area: 'Entrepreneurship & Philanthropy',
        videoUrl: 'https://example.com/video1.mp4',
        stepTitle: 'Developing Your Community-Minded Business Concept',
        stepDescription: `Want to turn your passion for making a difference into a thriving business? In this video, we'll guide you through the process of developing a community-minded business concept. Learn how to identify local needs, create a business model with social impact, and build a successful venture that strengthens your community. Pass and unlock Legalizing Your Business Video.`,
        preWorkshop: false, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
          { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
          { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
          { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
          { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
    
        ],
        nextStep: 10
      },
      {
        id: 10,
        area: 'Entrepreneurship & Philanthropy',
        videoUrl: 'https://example.com/video1.mp4',
        stepTitle: 'Legalizing Your Business',
        stepDescription: `Learn the ins and outs of legalizing your business. This video will guide you through the process step by step. Pass and unlock Opening Your Business Bank Account Video.`,
        preWorkshop: false, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
          { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
          { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
          { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
          { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
    
        ],
        nextStep: 11
      },
      {
        id: 11,
        area: 'Entrepreneurship & Philanthropy',
        videoUrl: 'https://example.com/video1.mp4',
        stepTitle: 'Opening Your Business Bank Account',
        stepDescription: `Lorem Ipsum Dolor`,
        preWorkshop: false, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
          { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
          { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
          { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
          { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
    
        ],
        nextStep: 12
      }
];

export default entrepreneurshipPhilanthropySteps;
